import React, {type JSX} from 'react';
import {styled} from '@mui/material/styles';
import {CircularProgress} from '@mui/material';
import {ViewFileWrapper} from '../viewerWrapper';

const LoadingWrapper = styled('div')(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'auto',
  backgroundColor: 'black',
}));

const LoadingDescriptionWrapper = styled('span')({
  marginTop: '24px',
  color: 'white',
});

type Props = {
  message?: string;
};

export function DicomLoadingScreen({
  message = 'Loading DICOM...',
}: Readonly<Props>): JSX.Element {
  return (
    <LoadingWrapper>
      <ViewFileWrapper>
        <CircularProgress color="primary" size={60} thickness={3} />
        <LoadingDescriptionWrapper>{message}</LoadingDescriptionWrapper>
      </ViewFileWrapper>
    </LoadingWrapper>
  );
}
